import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes from '../../../components/BobActionMenu.module.css';

const EquipmentTypeTableActionMenu = ({
    setCreateEquipmentTypeModalOpen,
    ...props
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const renderMenu = () => {
        return (
            <Paper className={classes.BobActionMenu}>
                <Button onClick={() => setCreateEquipmentTypeModalOpen(true)}>
                    <span className={'material-icons-outlined md-18'}>
                        add
                    </span>
                    <span className={classes.Icon}>
                        New Equipment Type
                    </span>
                </Button>
                {/*<Button>*/}
                {/*    <span className={'material-icons-outlined md-18'}>*/}
                {/*        delete*/}
                {/*    </span>*/}
                {/*    <span className={classes.Icon}>*/}
                {/*        Delete*/}
                {/*    </span>*/}
                {/*</Button>*/}
            </Paper>
        );
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    <Button
                        onClick={handleToggle}
                        className={menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}
                    >
                        Actions
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button>
                    {menuOpen ? renderMenu() : null}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default EquipmentTypeTableActionMenu;
